import { instance, source } from "./axios/instance";
import {
    unAuthenticatedinstance,
    unAuthenticatedSource,
} from "./axios/unAuthenticatedInstance";

function RequestHandler() {
    async function get(path, headers, options = {}) {
        return instance.get(path, {
            ...options,
            cancelToken: source.token,
            headers,
        });
    }

    async function post(path, body, headers, options = {}) {
        return instance.post(path, body, {
            ...options,
            cancelToken: source.token,
            headers,
        });
    }

    async function patch(path, body, headers, options = {}) {
        return instance.patch(path, body, {
            ...options,
            cancelToken: source.token,
            headers,
        });
    }

    async function put(path, body, headers, options = {}) {
        return instance.put(path, body, {
            ...options,
            cancelToken: source.token,
            headers,
        });
    }

    //Put request without authentication header
    async function unAuthenticatedPut(path, body, headers, options = {}) {
        return unAuthenticatedinstance.put(path, body, {
            ...options,
            cancelToken: unAuthenticatedSource.token,
            headers,
        });
    }

    async function remove(path, body, headers, options = {}) {
        return instance.delete(path, {
            ...options,
            data: body,
            cancelToken: source.token,
            headers,
        });
    }

    return {
        get,
        post,
        put,
        patch,
        remove,
        unAuthenticatedPut,
    };
}

export default RequestHandler();
